<template>
  <v-card>
    <v-card-title class="success">
      <h3 class="headline white--text">Suggested Free Chlorine (SUG)</h3>
    </v-card-title>
    <v-card-text>
      <v-layout row wrap>
        <v-flex xs6>
          <h4 class="subheading">Min: {{ sug.min }}</h4>
          <h4 class="subheading">SWG: {{ sug.swg }}</h4>
          <h4 class="subheading">Mustard: {{ sug.mustard }}</h4>
        </v-flex>
        <v-flex xs6>
          <h4 class="subheading">Target: {{ sug.target }}</h4>
          <h4 class="subheading">Shock: {{ sug.shock }}</h4>
        </v-flex>
      </v-layout>
      <br />
      <a
        target="_blank"
        href="https://www.poolcalculator.com/pool-maintenance/what-is-suggested-free-chlorine/"
        >Learn more about Suggested Free Chlorine »</a
      >
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SUG",
  components: {},
  computed: {
    ...mapGetters({
      cya: "cya/getCYA",
      settings: "settings/getSettings",
    }),
    sug() {
      return {
        swg: Math.max(1, Math.floor(this.cya.tested * 0.045 + 0.7)),
        min: Math.max(1, Math.floor(this.cya.tested * 0.075 + 0.7)),
        target: Math.max(3, Math.floor(this.cya.tested / 10 + 3.5)),
        shock: Math.max(10, Math.floor(this.cya.tested / 6 + 8.5)),
        mustard: Math.max(12, Math.floor(this.cya.tested / 2 + 4.5)),
      };
    },
  },
};
</script>
